import React, { useState, useEffect } from 'react';
import moment from 'moment';

import { toast } from 'react-toastify';

import ProgressBar from '../_components/progress-bar/component';

import { useLocation, useHistory } from 'react-router-dom';

import {
  generateCourseCertificateUrl,
  getCourseProgress,
  updateAlmaxExpiryDate,
  getCohortList,
  updateRefreshAlmaxExpiryDate,
  updateStudentCourseChange, generateNewIdCard, fetchUserSubscriptionDetails
} from '../../../services/apiService';

import Progress from './_tabs/progress';
import Profile from './_tabs/profile';
import AuditLogs from './_tabs/audit-logs';
import Woolf from './_tabs/woolf';

import { ArrowBack } from '@material-ui/icons';
import ExtendAlmaxExpiryDateModal from './_modals/ExtendAlmaxExpiryDateModal';

function UserBasicDetails({ userParams }) {
  return (
    <div
      style={{
        backgroundColor: 'var(--card-background, #fff)',
        borderRadius: 16,
        padding: '20px 24px',
        width: 384,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        border: '1px solid var(--border-light, rgba(0,0,0,0.07))',
        boxShadow: 'var(--shadow-sm, 0 1px 6px rgba(0,0,0,0.05))',
      }}
    >
      <div style={{ display: 'flex', gap: 8 }}>
        <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Id:</span>
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>{userParams.id}</span>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Name:</span>
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>
          {userParams?.firstName} {userParams?.lastName}
        </span>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Course:</span>
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>{userParams?.UserSubscriptions_courseType}</span>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Plan Type:</span>
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>{userParams?.UserSubscriptions_planType}</span>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>ERL Date:</span>
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>
          {moment(userParams?.UserSubscriptions_createdOn).format(
            'DD MMM YYYY'
          )}
        </span>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Cohort:</span>
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>{userParams?.UserSubscriptions_cohortName}</span>
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)' }}>Phone:</span>
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary, #111827)' }}>
          {userParams?.phone || '—'}
        </span>
        {userParams?.isPhoneVerified != null && (
          userParams.isPhoneVerified ? (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12, fontWeight: 600, color: '#2563EB' }}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="7" fill="#2563EB"/><path d="M4 7L6 9.5L10 5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
              Verified
            </span>
          ) : (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12, fontWeight: 600, color: '#9CA3AF' }}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="7" fill="#D1D5DB"/><path d="M4.5 4.5L9.5 9.5M9.5 4.5L4.5 9.5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/></svg>
              Unverified
            </span>
          )
        )}
      </div>
    </div>
  );
}
const getGoalType = (courseType) => {
  if (courseType === 'data-engineering') return 'dataEngineering';
  if (courseType === 'data-science') return 'dataScience';
  if (courseType === 'web3') return 'web3';
  return null;
};
function UserProgressDetails({ userParams }) {
  const [progressResp, setProgressResp] = useState(null);
  const [openExtendAlmaxModal, setOpenExtendAlmaxModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cohortList, setCohortList] = useState([]);
  const [subscriptionInfo, setSubscriptionInfo] = useState([]);
  const fetchStatusProgress = async (goalType, userId) => {
    try {
      const progressResp = await getCourseProgress(goalType, userId);
      setProgressResp(progressResp);
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch data');
    }
  };

  const handleGenerateCertificate = async () => {
    try {
      setLoading(true);
      const payload = {
        userId: userParams?.id,
        courseType: userParams?.UserSubscriptions_courseType,
      };

      const response = await generateCourseCertificateUrl(payload);
      if (response?.successful === true) {
        await fetchStatusProgress(
          getGoalType(userParams?.UserSubscriptions_courseType),
          userParams?.id
        );
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
      toast.error('Error Occured');
    } finally {
      setLoading(false);
    }
  };

  const handleGenerateNewIdCard = async () => {
    try {
      setLoading(true);
      const payload = {
        userId: userParams?.id,
        courseType: userParams?.UserSubscriptions_courseType,
      };

      const response = await generateNewIdCard(payload);
      toast.success(response.message);
    } catch (error) {
      console.error(error);
      toast.error('Error Occured');
    } finally {
      setLoading(false);
    }
  };

  const getUserSubscriptionInfo = async (userId,courseType) => {
    try {
      const response = await fetchUserSubscriptionDetails(userId, courseType);
      setSubscriptionInfo(response);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        await fetchStatusProgress(
          getGoalType(userParams?.UserSubscriptions_courseType),
          userParams?.id
        );
        await getUserSubscriptionInfo(userParams?.id,userParams?.UserSubscriptions_courseType);

        const resp = await getCohortList(
          userParams?.UserSubscriptions_courseType
        );
        setCohortList(
          resp.filter(
            (cohortItem) => cohortItem.id !== userParams?.UserSubscriptions_cohortId
          )
        );
      } catch (error) {
        console.error(error);
      }
    };

    if (userParams?.id) {
      loadData();
    }
  }, [userParams]);
  const handleExtendButtonClicked = async (date) => {
    try {
      await updateAlmaxExpiryDate({
        userId: userParams.id,
        courseType: getGoalType(userParams.UserSubscriptions_courseType),
        date,
      });
      fetchStatusProgress(
        getGoalType(userParams?.UserSubscriptions_courseType),
        userParams?.id
      );
      setOpenExtendAlmaxModal(false);
    } catch (e) {
      console.error(e);
      let message;
      if ([400, 500].includes(e.response?.status) && e.response?.data?.message)
        message = e.response.data.message;
      else message = 'Error extending date';
      toast.error(message);
    }
  };
  const [selectedCourse, setSelectedCourse] = useState(
    userParams?.UserSubscriptions_courseType || 'data-science'
  );


  const handleRefreshButtonClicked = async () => {
    try {
      await updateRefreshAlmaxExpiryDate({
        userId: userParams.id,
        courseType: getGoalType(userParams.UserSubscriptions_courseType),
      });
      fetchStatusProgress(
        getGoalType(userParams?.UserSubscriptions_courseType),
        userParams?.id
      );
      setOpenExtendAlmaxModal(false);
    } catch (e) {
      console.error(e);
      let message;
      if ([400, 500].includes(e.response?.status) && e.response?.data?.message)
        message = e.response.data.message;
      else message = 'Error extending date';
      toast.error(message);
    }
  };


  const handleChangeCourse = async () => {
    try {
      const data = {
        userId: userParams?.id,
        courseType: selectedCourse,
        subPlanType,
        cohort: cohort,
      };



      await updateStudentCourseChange(data);
      toast.success('Certificate name change request submitted');
    } catch (error) {
      console.error(error);
      toast.error('Failed to update certificate');
    }
  };


  const [subPlanType, setSubPlanType] = useState('iconic_iitg');
  const [cohort, setCohort] = useState('');

  return (
    <div
      style={{
        backgroundColor: 'var(--card-background, #fff)',
        borderRadius: 16,
        padding: '20px 24px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        border: '1px solid var(--border-light, rgba(0,0,0,0.07))',
        boxShadow: 'var(--shadow-sm, 0 1px 6px rgba(0,0,0,0.05))',
      }}
    >
      <ExtendAlmaxExpiryDateModal
        open={openExtendAlmaxModal}
        onClose={() => {
          setOpenExtendAlmaxModal(false);
        }}
        onExtendClicked={handleExtendButtonClicked}
      />
      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <div
          style={{
            width: '40%',
            fontSize: 13,
            color: 'var(--text-secondary, #6B7280)',
          }}
        >
          AlmaX Course Progress
        </div>
        <div style={{ width: '100%' }}>
          <ProgressBar
            progress={(progressResp?.almaXCourseProgress || 0) / 100}
            bold={true}
          />
        </div>
      </div>

      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <div
          style={{
            width: '40%',
            fontSize: 13,
            color: 'var(--text-secondary, #6B7280)',
          }}
        >
          Course Progress
        </div>
        <div style={{ width: '100%' }}>
          <ProgressBar
            progress={(progressResp?.courseProgress || 0) / 100}
            bold={true}
          />
        </div>
      </div>

      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <div
          style={{
            width: '40%',
            fontSize: 13,
            color: 'var(--text-secondary, #6B7280)',
          }}
        >
          ProX Progress
        </div>
        <div style={{ width: '100%' }}>
          <ProgressBar
            progress={(progressResp?.proXProgress || 0) / 100}
            bold={true}
          />
        </div>
      </div>

      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <div
          style={{
            width: '40%',
            fontSize: 13,
            color: 'var(--text-secondary, #6B7280)',
          }}
        >
          SSP Progress
        </div>
        <div style={{ width: '100%' }}>
          <ProgressBar
            progress={(progressResp?.sspProgress || 0) / 100}
            bold={true}
          />
        </div>
      </div>

      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <div
          style={{
            width: '40%',
            fontSize: 13,
            color: 'var(--text-secondary, #6B7280)',
          }}
        >
          Total Certificates
        </div>
        <div
          style={{
            width: '100%',
            fontSize: 13,
            fontWeight: 600,
            color: 'var(--text-primary, #111827)',
          }}
        >
          {progressResp?.totalCertificates || 0}
        </div>
      </div>
      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <div
          style={{
            width: '40%',
            fontSize: 13,
            color: 'var(--text-secondary, #6B7280)',
          }}
        >
          Almax Expiry Date
        </div>
        <div
          style={{
            width: '100%',
            fontSize: 13,
            fontWeight: 600,
            color: 'var(--text-primary, #111827)',
          }}
        >
          {progressResp?.userABCATData?.expiryDate
            ? moment(progressResp?.userABCATData?.expiryDate).format(
                'DD MMM YYYY'
              )
            : 'No Expiry Date Yet'}
        </div>
        {!progressResp?.userABCATData?.expiryDate ? (
          <div
            className='w-1/12'
            onClick={() => {
              handleRefreshButtonClicked();
            }}
          >
            Refresh
          </div>
        ) : (
          ''
        )}
        {progressResp?.userABCATData?.expiryDate ? (
          <div
            style={{
              width: '8%',
              fontSize: 13,
              fontWeight: 600,
              color: 'var(--primary-main, #4F46E5)',
              cursor: 'pointer',
            }}
            onClick={() => {
              setOpenExtendAlmaxModal(true);
            }}
          >
            Extend
          </div>
        ) : (
          ''
        )}
      </div>
      <div>
        {(progressResp?.proXProgress === 100 ||
          progressResp?.courseProgress === 100) &&
        progressResp?.certificateId === null ? (
          <button
            onClick={handleGenerateCertificate}
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: loading
                ? 'var(--text-disabled, #9CA3AF)'
                : 'var(--primary-main, #4F46E5)',
              backgroundColor: 'var(--card-background, #fff)',
              border: `1px solid ${
                loading
                  ? 'var(--text-disabled, #9CA3AF)'
                  : 'var(--primary-main, #4F46E5)'
              }`,
              borderRadius: 4,
              padding: '8px 16px',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.5 : 1,
            }}
            disabled={loading}
          >
            Generate Certificate
          </button>
        ) : null}
      </div>

      <div>
        <button
          onClick={handleGenerateNewIdCard}
          style={{
            fontSize: 13,
            fontWeight: 600,
            color: loading
              ? 'var(--text-disabled, #9CA3AF)'
              : 'var(--primary-main, #4F46E5)',
            backgroundColor: 'var(--card-background, #fff)',
            border: `1px solid ${
              loading
                ? 'var(--text-disabled, #9CA3AF)'
                : 'var(--primary-main, #4F46E5)'
            }`,
            borderRadius: 4,
            padding: '8px 16px',
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.5 : 1,
          }}
          disabled={loading}
        >
          Generate New Id Card
        </button>
        <a
          href={subscriptionInfo.idcard}
          target='_blank'
          rel='noopener noreferrer'
          style={{
            display: 'inline-block',
            padding: '8px 16px',
            border: '1px solid #ddd',
            borderRadius: '6px',
            textDecoration: 'none',
            color: '#333',
            backgroundColor: '#fff',
          }}
        >
          View ID Card
        </a>
      </div>
      <div style={{ marginTop: 16 }}>
        <div
          style={{
            backgroundColor: 'var(--card-background, #fff)',
            border: '1px solid var(--border-light, rgba(0,0,0,0.07))',
            borderRadius: 8,
            padding: 16,
            boxShadow: 'var(--shadow-sm, 0 1px 6px rgba(0,0,0,0.05))',
          }}
        >
          <h3
            style={{
              fontWeight: 600,
              fontSize: 18,
              marginBottom: 12,
              color: 'var(--text-primary, #111827)',
            }}
          >
            Course Change
          </h3>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: 16,
            }}
          >
            {/* Course */}
            <div>
              <label
                style={{
                  display: 'block',
                  fontWeight: 500,
                  marginBottom: 4,
                  color: 'var(--text-secondary, #6B7280)',
                }}
              >
                Course
              </label>
              <select
                value={selectedCourse}
                onChange={(e) => setSelectedCourse(e.target.value)}
                style={{
                  width: '100%',
                  border: '1px solid var(--border-main, #D1D5DB)',
                  borderRadius: 4,
                  padding: '8px 12px',
                  backgroundColor: 'var(--input-background, #fff)',
                  color: 'var(--text-primary, #111827)',
                  fontSize: 14,
                }}
              >
                <option value='data-science'>Data Science</option>
                <option value='web3'>Web Development</option>
              </select>
            </div>

            {/* Sub Plan */}
            <div>
              <label
                style={{
                  display: 'block',
                  fontWeight: 500,
                  marginBottom: 4,
                  color: 'var(--text-secondary, #6B7280)',
                }}
              >
                Sub Plan Type
              </label>
              <select
                value={subPlanType}
                onChange={(e) => setSubPlanType(e.target.value)}
                style={{
                  width: '100%',
                  border: '1px solid var(--border-main, #D1D5DB)',
                  borderRadius: 4,
                  padding: '8px 12px',
                  backgroundColor: 'var(--input-background, #fff)',
                  color: 'var(--text-primary, #111827)',
                  fontSize: 14,
                }}
              >
                <option value='iconic_iitg'>iconic_iitg</option>
                <option value='premium_ab'>premium_ab</option>
              </select>
            </div>

            {/* Cohort */}
            <div>
              <label
                style={{
                  display: 'block',
                  fontWeight: 500,
                  marginBottom: 4,
                  color: 'var(--text-secondary, #6B7280)',
                }}
              >
                Cohort
              </label>
              <select
                value={cohort}
                onChange={(e) => setCohort(e.target.value)}
                style={{
                  width: '100%',
                  border: '1px solid var(--border-main, #D1D5DB)',
                  borderRadius: 4,
                  padding: '8px 12px',
                  backgroundColor: 'var(--input-background, #fff)',
                  color: 'var(--text-primary, #111827)',
                  fontSize: 14,
                }}
              >
                <option value=''>Select Cohort</option>

                {cohortList?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div style={{ marginTop: 16 }}>
            <button
              style={{
                backgroundColor: 'var(--primary-main, #4F46E5)',
                color: '#fff',
                padding: '8px 16px',
                borderRadius: 4,
                border: 'none',
                fontSize: 14,
                fontWeight: 500,
                cursor: 'pointer',
              }}
              onClick={handleChangeCourse}
            >
              Update Course
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function UserDetails() {
  const location = useLocation();
  const history = useHistory();

  const [tab, setTab] = useState('profile');
  const [userParams, setUserParams] = useState(null);

  useEffect(() => {
    const userParams = location.state?.userParams;
    if (!userParams) {
      history.replace('/all-users');
      return;
    }
    setUserParams(userParams);
  }, []);
  if (!userParams) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      {/* Header */}
      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <ArrowBack
          style={{ cursor: 'pointer', color: 'var(--text-primary, #111827)' }}
          onClick={() => {
            history.goBack();
          }}
        />
        <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--heading-primary, #111827)', margin: 0 }}>
          Student Details
        </h1>
      </div>

      {/* Cards */}
      <div style={{ display: 'flex', gap: 16 }}>
        <UserBasicDetails userParams={userParams} />
        <UserProgressDetails userParams={userParams} />
      </div>

      {/* Tab container */}
      <div
        style={{
          backgroundColor: 'var(--card-background, #fff)',
          borderRadius: 16,
          padding: '0 20px',
          border: '1px solid var(--border-light, rgba(0,0,0,0.07))',
          boxShadow: 'var(--shadow-sm, 0 1px 6px rgba(0,0,0,0.05))',
        }}
      >
        {/* Tab menu */}
        <div style={{ display: 'flex', gap: 32, borderBottom: '1px solid var(--border-light, rgba(0,0,0,0.07))' }}>
          <h2
            style={{
              fontSize: 14,
              fontWeight: tab === 'profile' ? 600 : 400,
              color: tab === 'profile' ? 'var(--primary-main, #4F46E5)' : 'var(--text-secondary, #6B7280)',
              cursor: 'pointer',
              padding: '12px 0',
              margin: 0,
              borderBottom: tab === 'profile' ? '2px solid var(--primary-main, #4F46E5)' : '2px solid transparent',
              transition: 'all 150ms ease',
            }}
            onClick={() => setTab('profile')}
          >
            Profile
          </h2>
          <h2
            style={{
              fontSize: 14,
              fontWeight: tab === 'progress' ? 600 : 400,
              color: tab === 'progress' ? 'var(--primary-main, #4F46E5)' : 'var(--text-secondary, #6B7280)',
              cursor: 'pointer',
              padding: '12px 0',
              margin: 0,
              borderBottom: tab === 'progress' ? '2px solid var(--primary-main, #4F46E5)' : '2px solid transparent',
              transition: 'all 150ms ease',
            }}
            onClick={() => setTab('progress')}
          >
            Progress
          </h2>
          <h2
            style={{
              fontSize: 14,
              fontWeight: tab === 'auditLogs' ? 600 : 400,
              color: tab === 'auditLogs' ? 'var(--primary-main, #4F46E5)' : 'var(--text-secondary, #6B7280)',
              cursor: 'pointer',
              padding: '12px 0',
              margin: 0,
              borderBottom: tab === 'auditLogs' ? '2px solid var(--primary-main, #4F46E5)' : '2px solid transparent',
              transition: 'all 150ms ease',
            }}
            onClick={() => setTab('auditLogs')}
          >
            Audit Logs
          </h2>
          <h2
            style={{
              fontSize: 14,
              fontWeight: tab === 'woolf' ? 600 : 400,
              color: tab === 'woolf' ? 'var(--primary-main, #4F46E5)' : 'var(--text-secondary, #6B7280)',
              cursor: 'pointer',
              padding: '12px 0',
              margin: 0,
              borderBottom: tab === 'woolf' ? '2px solid var(--primary-main, #4F46E5)' : '2px solid transparent',
              transition: 'all 150ms ease',
            }}
            onClick={() => setTab('woolf')}
          >
            Woolf Activities
          </h2>
        </div>
      </div>

      {tab === 'profile' && <Profile />}

      {tab === 'progress' && <Progress />}

      {tab === 'auditLogs' && <AuditLogs />}

      {tab === 'woolf' && <Woolf />}
    </div>
  );
}

export default UserDetails;
